var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 154,
    height: 48,
    viewBox: "0 0 154 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.2264 8.46902V13.4518H87.4172V21.3217H93.0881V8.46902H84.2264Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.277832 8.46902V13.4518H3.46861V47.9645H9.13947V8.46902H0.277832Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.126 8.48918L27.1377 13.4261C27.1377 13.4261 32.7354 13.4147 35.5343 13.4261C36.3824 13.429 37.2364 13.472 38.067 13.6383C39.4094 13.9049 40.5062 14.6704 41.211 15.8258C41.6585 16.5597 41.8661 17.4055 41.8661 18.2598C41.8661 18.4204 41.9275 36.5196 41.9275 37.7008H47.5165V18.6612C47.5165 14.8109 45.1066 11.1641 41.5795 9.50122C39.8452 8.68414 37.8974 8.50352 35.9993 8.49205C33.0367 8.47198 27.1289 8.48631 27.1289 8.48631L27.126 8.48918Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6931 13.4518H16.8868V37.7007H22.5577V8.46902H13.6931V13.4518Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.197 13.5493V8.52926H103.816V0H98.1243V13.5092H114.999L104.983 37.6606H111.195L121.197 13.5493Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M149.352 12.7524C146.521 9.97713 143.111 8.55511 139.128 8.48917H126.18V37.7209H131.872V14.0683H139.049C141.488 14.1199 143.582 14.9972 145.331 16.6973C147.132 18.4634 148.033 20.5964 148.033 23.0936C148.033 25.5907 147.138 27.718 145.351 29.4697L145.331 29.4898C143.541 31.2444 141.374 32.1188 138.826 32.1188C138.435 32.1188 137.484 32.1045 135.981 32.0787V37.6578C137.484 37.6836 138.435 37.6979 138.826 37.6979C142.947 37.6979 146.457 36.2759 149.355 33.4348C149.355 33.4204 149.361 33.4147 149.376 33.4147C152.277 30.5706 153.724 27.1303 153.724 23.0936C153.724 19.0569 152.268 15.6079 149.355 12.7524",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1497 16.2701C72.3729 16.2701 75.7538 19.8681 75.2741 24.1026C74.9086 27.328 72.2589 29.9226 68.9716 30.2839C64.6519 30.7569 60.9815 27.4398 60.9815 23.2999V16.2729H68.1497M68.1497 8.7041H53.2604V23.2999C53.2604 31.3618 59.9257 37.8957 68.1497 37.8957C76.3738 37.8957 83.0391 31.3618 83.0391 23.2999C83.0391 15.2379 76.3738 8.7041 68.1497 8.7041Z",
    fill: "url(#paint0_linear_3383_5420)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3383_5420",
    x1: 53.2604,
    y1: 23.297,
    x2: 83.0391,
    y2: 23.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE1918"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A31933"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6ee51cd833129ebf2f3c78a32954c516.svg";
export { ForwardRef as ReactComponent };